import Config from "./config.types";
import configPreprod from './config.dev';

const config: Config = {
    ...configPreprod,
    /* OVERRIDE HERE ONLY NECESSARY CONFIG ! */
};

export default config;
